import {
    CButton,
    CTable,
    CTableBody,
    CTableDataCell,
    CTableHead,
    CTableHeaderCell,
    CTableRow,
} from "@coreui/react";
import CIcon from "@coreui/icons-react";
import { cilPencil, cilTrash } from "@coreui/icons";
import React from "react";
import TableFooterV2 from './TableFooterV2';


const Table = ({
    columns,
    data,
    pagination,
    setFaqsPage,
    handleFaqSelected,
}) => {
    return (
        <>
            <CTable responsive hover>
                <CTableHead>
                    <CTableRow>
                        {columns.map((col, index) => (
                            <CTableHeaderCell
                                key={index}
                                scope="col"
                                className={col._props.className}
                            >
                                {col.label}
                            </CTableHeaderCell>
                        ))}
                    </CTableRow>
                </CTableHead>
                <CTableBody>
                    {data.map((el, index) => (
                        <CTableRow key={index}>
                            <CTableDataCell>{el?.question}</CTableDataCell>
                            <CTableDataCell>{el?.answer}</CTableDataCell>
                            <CTableDataCell>
                                <div className="d-flex gap-2">
                                    <CButton
                                        color="primary"
                                        size="sm"
                                        className="me-1"
                                        onClick={() => {
                                            handleFaqSelected(
                                                el.id,
                                                "edit"
                                            );
                                        }}
                                    >
                                        <CIcon icon={cilPencil} />
                                    </CButton>

                                    <CButton
                                        color="danger"
                                        size="sm"
                                        className="me-1"
                                        onClick={() => {
                                            handleFaqSelected(
                                                el.id,
                                                "delete"
                                            );
                                        }}
                                    >
                                        <CIcon icon={cilTrash} />
                                    </CButton>
                                </div>
                            </CTableDataCell>
                        </CTableRow>
                    ))}
                </CTableBody>
            </CTable>
            <TableFooterV2 range={pagination?.links} setPage={setFaqsPage} />
        </>
    );
};

export default Table;
